module.exports = __webpack_public_path__ + "static/media/marketplace.a82dd478.png";